import firestore from '@paperstac/firebase/lib/firestore';
export var settingsRef = function settingsRef() {
  return firestore.collection('settings').doc('global');
};